export default __webpack_public_path__ + "static/media/imageTum2.a648c547.jpg";